import { Feedback } from '@interfaces';
import FeedbackService from '@services/feedback';
import { QueryObserverResult, useQuery } from '@tanstack/react-query';

export const useGetFeedback = (): QueryObserverResult<Feedback, Error> =>
  useQuery<Feedback, Error>({ queryKey: ['get-feedback'], queryFn: () => FeedbackService.getFeedback() });
